// frontend/src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

// Follex Tech — Firebase project: folex-tech-store
const firebaseConfig = {
  apiKey: "AIzaSyDjAU-UocJivGv-0_l1rjbAXXVp8soCfoY",
  authDomain: "folex-tech-store.firebaseapp.com",
  projectId:  "folex-tech-store",
  storageBucket: "folex-tech-store.firebasestorage.app",
  messagingSenderId: "582836984993",
  appId: "1:582836984993:web:20a8086df7a917488ae4e0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth, firebaseConfig };